import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

function RehabEnquiry() {
  return (
    <>
      <Helmet>
        <title>Rehab Centre Enquiry | Whitstable House</title>
        <meta
          name="description"
          content="Enquire about Whitstable House Physical Rehabilitation Centre for recovery after illness, injury, surgery or functional decline."
        />
        <link rel="canonical" href="https://www.whitstable.house/RehabEnquiry" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section care-suites-enquiry-page">
            <div className="care-suites-enquiry-container">
              <h1>Rehab Centre Enquiry</h1>

              <div className="contact-layout care-suites-enquiry-layout">
                <div className="care-suites-enquiry-content">
                  <section className="care-suites-enquiry-block">
                    <h2>Who is the Physical Rehabilitation Centre suitable for?</h2>
                    <p>
                      Our Physical Rehabilitation Centre is designed for individuals recovering from illness,
                      injury, surgery or functional decline who require specialist therapy and support to regain
                      strength, confidence and independence. This may include people requiring early discharge
                      support from acute hospital settings, post-operative orthopaedic rehabilitation, neurological
                      rehabilitation, cardiac and respiratory reconditioning, frailty support, sports injury
                      rehabilitation, or women&apos;s health rehabilitation.
                    </p>
                    <p>
                      Unlike long-term care environments, the Rehabilitation Centre focuses on recovery, rebuilding
                      function and helping individuals return to everyday life with the highest possible level of
                      independence and wellbeing.
                    </p>
                    <p>
                      The centre is led by a Chartered Physiotherapist (MCSP), registered with the Health and Care
                      Professions Council (HCPC), with over 14 years of clinical experience across both NHS and
                      private practice settings. Using specialist rehabilitation technology rarely available outside
                      of a hospital environment, alongside a range of evidence-based rehabilitation models, our team
                      delivers highly personalised programmes tailored to each individual&apos;s goals and recovery
                      journey.
                    </p>
                    <p>
                      Our aim is not simply to help people recover, but to support them in returning to a life where
                      they are not just living, but thriving.
                    </p>
                    <img
                      src="/Physio_1(1).jpeg"
                      alt="Physical rehabilitation at Whitstable House"
                      className="care-suites-enquiry-block__image"
                    />
                  </section>
                </div>

                <div className="contact-right-column">
                  <section className="contact-section-main">
                    <h2>
                      For more information or to ask any questions you might have, please phone, email or write to
                      us.
                    </h2>

                    <div className="contact-details">
                      <div className="contact-address">
                        <p>Whitstable House</p>
                        <p>Boorman Way</p>
                        <p>Whitstable</p>
                        <p>Kent</p>
                        <p>CT5 3SE</p>
                      </div>

                      <div className="contact-info">
                        <p>
                          <strong>Tel:</strong>{' '}
                          <a href="tel:01227533522">01227 533522</a>
                        </p>
                        <p>
                          <strong>Email:</strong>{' '}
                          <a href="mailto:rehab@whitstable.house">rehab@whitstable.house</a>
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className="find-us-section">
                    <h2>Find Us</h2>
                    <p>
                      Our Physical Rehabilitation Centre at Whitstable House overlooks the Thames Estuary and is
                      within easy reach of Estuary View Medical Centre — a picturesque setting for recovery and
                      rehabilitation.
                    </p>

                    <div className="map-container">
                      <iframe
                        src="https://www.google.com/maps?q=Whitstable+House,+Boorman+Way,+Whitstable+CT5+3SE&output=embed"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Whitstable House Location"
                        className="google-map-iframe"
                      />
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Whitstable House <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
                <p>Copyright © Whitstable House</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default RehabEnquiry;
